/**
 * Core-100 R4 — CORE-AZ: the customer's own reply to a reminder, shown to the advisor on the ticket.
 * Confirmed / asked to cancel; NO reply renders nothing (unknown remains unknown). A cancellation
 * request does not cancel anything — the shop decides.
 */
import { Badge } from '@/components/ui/badge';
import { customerReplyLabel } from '@/lib/ocis/customerReply';

export function CustomerReplyBadge({ customerConfirmed }: { customerConfirmed: boolean | null | undefined }) {
  const label = customerReplyLabel(customerConfirmed);
  if (!label) return null;
  return (
    <Badge
      variant="outline"
      title={label.detail}
      data-testid={`customer-reply-${label.kind}`}
      className={label.kind === 'confirmed'
        ? 'text-xs bg-green-500/10 text-green-700 dark:text-green-300 border-green-400'
        : 'text-xs bg-red-500/10 text-red-700 dark:text-red-300 border-red-400'}
    >
      {label.text}
    </Badge>
  );
}
